"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTrackingMeta = getTrackingMeta;
exports.trackInteraction = trackInteraction;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Constants = require("../Constants");

var _ActionTypes = require("./ActionTypes");

var _tracking = require("../utils/tracking");

function getTrackingMeta(name, action, meta) {
  return (0, _defineProperty2.default)({}, _Constants.TRACK_EVENT, {
    name: name,
    eventKey: (0, _tracking.getUsageTrackerJsEventName)(name),
    action: action,
    meta: meta
  });
}

function trackInteraction(name, action) {
  var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return {
    type: _ActionTypes.TRACK_INTERACTION,
    meta: getTrackingMeta(name, action, meta)
  };
}